import { EventEmitter, Component, HostBinding, Input, ViewChild, Output, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

/**
 * @fileoverview added by tsickle
 * Generated from: b2c-infinite-scroll.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@angular/common';

const _c0 = ["infanchor"];
const _c1 = ["container"];
const _c2 = function (a0) { return { "max-height.px": a0 }; };
const _c3 = function (a0, a1) { return { container: a0, "": a1 }; };
const _c4 = ["*"];
class B2CInfiniteScrollComponent {
    constructor() {
        this.infScroll = true;
        this.maxHeight = 220;
        this.showContainer = true;
        this.scrolled = new EventEmitter();
    }
    /**
     * @return {?}
     */
    ngOnInit() { }
    /**
     * @return {?}
     */
    ngAfterViewInit() {
        /** @type {?} */
        const options = {
            root: this.container.nativeElement
        };
        this.observer = new IntersectionObserver((/**
         * @param {?} __0
         * @return {?}
         */
        ([entry]) => {
            if (entry.isIntersecting) {
                this.scrolled.emit();
            }
        }), options);
        this.observer.observe(this.anchor.nativeElement);
    }
    /**
     * @return {?}
     */
    ngOnDestroy() {
        this.observer.disconnect();
    }
}
B2CInfiniteScrollComponent.ɵfac = function B2CInfiniteScrollComponent_Factory(t) { return new (t || B2CInfiniteScrollComponent)(); };
B2CInfiniteScrollComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: B2CInfiniteScrollComponent, selectors: [["b2c-infinite-scroll"]], viewQuery: function B2CInfiniteScrollComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(_c0, true);
        ɵngcc0.ɵɵviewQuery(_c1, true);
    } if (rf & 2) {
        var _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.anchor = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.container = _t.first);
    } }, hostVars: 2, hostBindings: function B2CInfiniteScrollComponent_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵclassProp("b2c-inf-scroll", ctx.infScroll);
    } }, inputs: { maxHeight: "maxHeight", showContainer: "showContainer" }, outputs: { scrolled: "scrolled" }, ngContentSelectors: _c4, decls: 5, vars: 7, consts: [[1, "inf-scroll-container", 3, "ngStyle", "ngClass"], ["container", ""], ["infanchor", ""]], template: function B2CInfiniteScrollComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵelementStart(0, "div", 0, 1);
        ɵngcc0.ɵɵprojection(2);
        ɵngcc0.ɵɵelement(3, "div", null, 2);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngStyle", ɵngcc0.ɵɵpureFunction1(2, _c2, ctx.maxHeight))("ngClass", ɵngcc0.ɵɵpureFunction2(4, _c3, ctx.showContainer, !ctx.showContainer));
    } }, directives: [ɵngcc1.NgStyle, ɵngcc1.NgClass], encapsulation: 2 });
B2CInfiniteScrollComponent.propDecorators = {
    infScroll: [{ type: HostBinding, args: ['class.b2c-inf-scroll',] }],
    maxHeight: [{ type: Input }],
    showContainer: [{ type: Input }],
    anchor: [{ type: ViewChild, args: ['infanchor', { static: false },] }],
    container: [{ type: ViewChild, args: ['container', { static: false },] }],
    scrolled: [{ type: Output }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(B2CInfiniteScrollComponent, [{
        type: Component,
        args: [{
                selector: 'b2c-infinite-scroll',
                template: `
    <div
      class="inf-scroll-container"
      [ngStyle]="{ 'max-height.px': maxHeight }"
      [ngClass]="{ container: showContainer, '': !showContainer }"
      #container
    >
      <ng-content></ng-content>
      <div #infanchor></div>
    </div>
  `
            }]
    }], function () { return []; }, { infScroll: [{
            type: HostBinding,
            args: ['class.b2c-inf-scroll']
        }], maxHeight: [{
            type: Input
        }], showContainer: [{
            type: Input
        }], scrolled: [{
            type: Output
        }], anchor: [{
            type: ViewChild,
            args: ['infanchor', { static: false }]
        }], container: [{
            type: ViewChild,
            args: ['container', { static: false }]
        }] }); })();
if (false) {
    /** @type {?} */
    B2CInfiniteScrollComponent.prototype.infScroll;
    /** @type {?} */
    B2CInfiniteScrollComponent.prototype.maxHeight;
    /** @type {?} */
    B2CInfiniteScrollComponent.prototype.showContainer;
    /** @type {?} */
    B2CInfiniteScrollComponent.prototype.anchor;
    /** @type {?} */
    B2CInfiniteScrollComponent.prototype.container;
    /** @type {?} */
    B2CInfiniteScrollComponent.prototype.scrolled;
    /**
     * @type {?}
     * @private
     */
    B2CInfiniteScrollComponent.prototype.observer;
}

/**
 * @fileoverview added by tsickle
 * Generated from: b2c-infinite-scroll.module.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class B2CInfiniteScrollModule {
}
B2CInfiniteScrollModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: B2CInfiniteScrollModule });
B2CInfiniteScrollModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function B2CInfiniteScrollModule_Factory(t) { return new (t || B2CInfiniteScrollModule)(); }, imports: [[CommonModule]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(B2CInfiniteScrollModule, { declarations: function () { return [B2CInfiniteScrollComponent]; }, imports: function () { return [CommonModule]; }, exports: function () { return [B2CInfiniteScrollComponent]; } }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(B2CInfiniteScrollModule, [{
        type: NgModule,
        args: [{
                declarations: [B2CInfiniteScrollComponent],
                exports: [B2CInfiniteScrollComponent],
                imports: [CommonModule]
            }]
    }], null, null); })();

/**
 * @fileoverview added by tsickle
 * Generated from: public_api.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * Generated from: b2c-ui-infinite-scroll.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

export { B2CInfiniteScrollComponent, B2CInfiniteScrollModule };


//# sourceMappingURL=b2c-ui-infinite-scroll.js.map